import { Injectable } from '@angular/core';
import { AccountDto, AccountPatchBody, AccountPostBody } from '@mkp/account/models';
import { getOptionalContext } from '@mkp/core/feature-interceptor';
import { BaseHttpResource, escapeDelimiters } from '@mkp/shared/data-access';
import { CoreListEnvelop, isUuid } from '@mkp/shared/models';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccountResource extends BaseHttpResource<
  AccountDto,
  CoreListEnvelop<AccountDto>,
  AccountPostBody,
  AccountPatchBody
> {
  constructor() {
    super('account');
  }

  getCandidlyDashboardLink(accountId: string): Observable<string | undefined> {
    return this.http
      .get<AccountDto>(`${this.url}/${accountId}`, {
        context: getOptionalContext(),
      })
      .pipe(map((account) => account._links.candidlyDashboard?.href));
  }

  fetchByIds(accountIds: string[]): Observable<AccountDto[]> {
    return this.getWithQuery({ filter: getIdsFilter(accountIds), limit: 500 }).pipe(
      map(({ _embedded: { results: accounts } }) => accounts)
    );
  }

  search(searchTerm: string): Observable<AccountDto[]> {
    return this.getWithQuery({
      limit: 20,
      filter: getSearchFilter(searchTerm),
    }).pipe(map(({ _embedded: { results: accounts } }) => accounts));
  }
}

const getIdsFilter = (accountIds: string[]): string =>
  accountIds.map((accountId) => `id==${accountId}`).join(',');

const getSearchFilter = (searchTerm: string): string =>
  isUuid(searchTerm)
    ? `legalEntity.companyProfiles.id==${searchTerm}`
    : searchTerm
        .split(' ')
        .map(
          (word) => `legalEntity.name=@${escapeDelimiters(word)},name=@${escapeDelimiters(word)}`
        )
        .join(';');
